module.exports = __webpack_public_path__ + "img/d7sj-btn.0a60d4d7.png";